var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor comment-reply" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Comment ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Comment ID",
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.commentId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "commentId", $$v)
            },
            expression: "clone.commentId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Message")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Message ",
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.message,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "message", $$v)
            },
            expression: "clone.message",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }